<template>
  <div>
    <div class="ebs-count">
      <div class="dropdown is-right is-active">
        <div class="dropdown-trigger" @click="trigger_dropdown()" v-tooltip="{ content: localization('app-display-tickets', 'Display Tickets') }">
          <a aria-haspopup="true" aria-controls="dropdown-menu">
            <img v-if="type" class="cluster-dd-trigger" src="@/assets/icons/cluster-active.svg" alt />
            <img v-else class="cluster-dd-trigger" src="@/assets/icons/cluster-inactive.svg" alt />
          </a>
        </div>
        <div v-if="is_dropdown" class="dropdown-menu" id="dropdown-menu" role="menu">
          <div class="cluster-heading">
            <span class="is-bold-16-000-106" v-if="lang_data">{{ localization("app-group-by", "Group By") }}</span>
            <img class="is-pointer" @click="is_dropdown = false" src="@/assets/icons/close.svg" alt />
          </div>
          <div class="middle">
            <a
              @click="
                type = 'status';
                load_cluster();
              "
              class="is-semibold-16-000-106 middle-button"
              :class="{ 'middle-button-active': type === 'status' }"
            >
              <img v-if="type === 'status'" src="@/assets/icons/active-status.svg" />
              <img v-else src="@/assets/icons/inactive-status.svg" />
              <span v-if="lang_data">{{ localization("app-status", "status") }}</span>
            </a>
            <a
              @click="
                type = 'priority';
                load_cluster();
              "
              class="middle-button"
              :class="{ 'middle-button-active': type === 'priority' }"
            >
              <img v-if="type === 'priority'" src="@/assets/icons/active-priority.svg" />
              <img v-else src="@/assets/icons/inactive-priority.svg" />
              <span v-if="lang_data">{{ localization("app-priority", "priority") }}</span>
            </a>
          </div>
          <div @click="clear_cluster()" class="is-semibold-16-000-106 clear-all">
            {{ localization("app-clear-all", "Clear All") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ApiService from "@/api.service";
  import { mapMutations, mapState } from "vuex";
  import { DateTime } from "luxon";
  function prettydate(date) {
    if (!date) return "";
    let givenDate = new DateTime.fromISO(date);
    let today = new DateTime.local();
    if (today.diff(givenDate, "days").days < 7) return givenDate.toRelative({ base: today });
    return givenDate.toFormat("DDDD");
  }

  export default {
    data() {
      return {
        type: "",
        is_dropdown: false,
        tickets: null,
        apiService: new ApiService(),
        priorities: {
          1: "Critical",
          2: "High",
          3: "Medium",
          4: "Low",
        },
        statuses: {
          1: "pending",
          2: "in progress",
          3: "resolved",
          4: "closed",
          5: "rejected",
        },
      };
    },
    computed: {
      ...mapState(["map", "draw", "cluster_active_layer", "active_layers"]),
    },
    created() {
      let action = (data) => {
        if (this.type && data === "on_load_templates_complete") {
          console.log("load cluster therm");
          this.load_cluster();
        } else if (this.type && (data.name === "tickets_updates" || data.name === "tickets-bulk-create-completeds")) {
          this.load_cluster();
        } else if (data.name === "single-ticket-create-completed" || data.name === "create-project-ticket-completed") {
          this.$root.$emit(data.name);
        }
      };
      if (window.addEventListener) {
        window.addEventListener("message", (e) => action(e.data), false);
      } else if (window.attachEvent) {
        window.attachEvent("onmessage", (e) => action(e.data));
      }
    },
    watch: {
      map: {
        handler(val) {
          if (this.map)
            this.map.on("style.load", () => {
              for (let i = 1; i <= 4; i++) {
                this.map.loadImage("/img/icons/priority/" + i + ".png", (error, image) => {
                  if (error) throw error;
                  this.map.addImage("priority" + i, image);
                });
              }
              for (let i = 1; i <= 5; i++) {
                this.map.loadImage("/img/icons/status/" + i + ".png", (error, image) => {
                  if (error) throw error;
                  this.map.addImage("status" + i, image);
                });
              }

              if (this.map.getSource("assets")) this.map.removeSource("assets");
              if (this.map.getLayer("asset_label")) this.map.removeLayer("asset_label");
              if (this.map.getLayer("asset_circle")) this.map.removeLayer("asset_circle");
              if (this.cluster_active_layer && this.type) this.load_cluster();
            });

          var popup = new mapboxgl.Popup({
            closeButton: false,
            className: "ticket-cluster-popup",
            offset: 0,
          });

          document.addEventListener(
            "click",
            (event) => {
              // If the clicked element doesn't have the right selector, bail
              if (!event.target.matches(".ticket-cluster-popup-action")) return;

              // Don't follow the link
              event.preventDefault();

              // Log the clicked element in the console
              console.log(event.target.getAttribute("data-ticket"));
              this.open_details_popup(event.target.getAttribute("data-ticket"));
            },
            false
          );
          if (this.map)
            this.map.on("mouseenter", "asset_label", (e) => {
              // Change the cursor style as a UI indicator.
              this.map.getCanvas().style.cursor = "pointer";

              var coordinates = e.features[0].geometry.coordinates.slice();
              var description = this.get_popup_html(JSON.parse(e.features[0].properties.ticket));

              // Ensure that if the map is zoomed out such that multiple
              // copies of the feature are visible, the popup appears
              // over the copy being pointed to.
              while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
              }

              // Populate the popup and set its coordinates
              // based on the feature found.
              popup
                .setLngLat(coordinates)
                .setHTML(description)
                .addTo(this.map);
            });
          // this.map.on("mouseleave", "asset_label", () => {
          //   this.map.getCanvas().style.cursor = "";
          //   popup.remove();
          // });
          if (this.map) {
            for (let i = 1; i <= 4; i++) {
              this.map.loadImage("/img/icons/priority/" + i + ".png", (error, image) => {
                if (error) throw error;
                this.map.addImage("priority" + i, image);
              });
            }
            for (let i = 1; i <= 5; i++) {
              this.map.loadImage("/img/icons/status/" + i + ".png", (error, image) => {
                if (error) throw error;
                this.map.addImage("status" + i, image);
              });
            }
          }
        },
        immediate: true,
      },
      cluster_active_layer(val) {
        if (this.map.getSource("assets")) this.map.removeSource("assets");
        if (this.map.getLayer("asset_label")) this.map.removeLayer("asset_label");
        if (this.map.getLayer("asset_circle")) this.map.removeLayer("asset_circle");
        if (val && this.type) this.load_cluster();
      },
      active_layers() {
        if (this.map.getSource("assets")) this.map.removeSource("assets");
        if (this.map.getLayer("asset_label")) this.map.removeLayer("asset_label");
        if (this.map.getLayer("asset_circle")) this.map.removeLayer("asset_circle");
        if (this.type) this.load_cluster();
      },
    },
    methods: {
      trigger_dropdown() {
        this.is_dropdown = true;
        if (!this.type) {
          this.type = "status";
          this.load_cluster();
        }
      },
      get_popup_html(ticket) {
        return (
          `<div class="ticket-cluster-popup">` +
          `<div class="top">` +
          `<div class="top-status"><img src=".\/img\/icons\/status\/${ticket.status}.png" >` +
          `<p>${this.localization("app-" + this.statuses[ticket.status].toLowerCase().replace(" ", "-"), this.statuses[ticket.status])}</p>` +
          `</div>` +
          `<div class="top-priority">` +
          `<img src=".\/img\/icons\/priority\/${ticket.priority}.png">` +
          `<p>${this.localization("app-" + this.priorities[ticket.priority].toLowerCase().replace(" ", "-"), this.priorities[ticket.priority])}</p>` +
          `</div>` +
          `</div>` +
          `<div class="middle">${ticket.name}</div>` +
          `<div class="bottom">` +
          `<div class="bottom-due-date"><img src=".\/img\/icons\/clock.svg"><span> ${prettydate(ticket.dueDate || ticket.createdAt)} </span> </div>` +
          `<a class="bottom-see-more"><span class="ticket-cluster-popup-action" data-ticket='${JSON.stringify(ticket)}' >
          ${this.localization("app-see-more", "See More")}` +
          `</span><img class="ticket-cluster-popup-action" data-ticket="${ticket}" src=".\/img\/icons\/see-more.svg"></a>` +
          `</div>` +
          `</div>`
        );
      },
      open_details_popup(ticket) {
        parent.postMessage(
          {
            name: "show_ticket_details",
            ticket: JSON.parse(ticket),
          },
          "*"
        );
      },
      clear_cluster() {
        if (this.map.getLayer("asset_circle")) this.map.removeLayer("asset_circle");
        if (this.map.getLayer("asset_label")) this.map.removeLayer("asset_label");
        if (this.map.getSource("assets")) this.map.removeSource("assets");
        this.is_dropdown = false;
        this.type = "";
      },
      async load_cluster() {
        let type = this.type;
        try {
          let queryBoundary;

          let map_bounds = [];

          for (let project of Object.values(this.active_layers)) {
            if (project.is_ortho_active && project.meta && project.meta.bounds) {
              map_bounds.push(turf.bboxPolygon(project.meta.bounds));
            }
          }
          if (map_bounds && map_bounds.length) queryBoundary = turf.union(...map_bounds);

          if (queryBoundary && this.$store.getters.debug) {
            queryBoundary.id = "load_clusters";
            this.draw.add(queryBoundary);
          }
          let polygon = queryBoundary && queryBoundary.geometry ? btoa(JSON.stringify(queryBoundary.geometry)) : "";
          this.tickets = (
            await this.apiService.get_tickets({
              query: `stage=therm&pageSize=10000000&polygon=${polygon}`,
            })
          ).data;
          // elements filtering
          console.log("this.tickets.length", this.tickets.length);
          let elements = {};
          Object.values(this.active_layers || {}).forEach((layer) => {
            if (layer.is_ortho_active && layer.project_elements) {
              (layer.project_elements || []).forEach((el_uid) => {
                elements[el_uid] = true;
              });
              if (layer.project_details && layer.project_details.element && _.isObject(layer.project_details.element))
                elements[layer.project_details.element.uid] = true;
            }
          });
          this.tickets = _.filter(this.tickets || [], (t) => t.targetElement && elements[t.targetElement.uid]);
          console.log("this.tickets.length", this.tickets.length);
        } catch (err) {
          console.log(err);
          this.tickets = [];
        }
        if (!this.tickets.length) return;

        let features = this.tickets.map((t) => {
          if (t.location) {
            let feature = turf.feature(t.location);
            feature.properties["priority"] = t.priority || 0;
            feature.properties["status"] = t.status || 0;
            feature.properties["ticket"] = t;
            return feature;
          }
          return turf.feature({
            type: "Point",
            coordinates: [0, 0],
            properties: {
              priority: 0,
              status: 0,
              ticket: {},
            },
          });
        });

        let featuresCollection = { type: "FeatureCollection", features };

        var map = this.map;

        // filters for classifying assets into five categories based on magnitude
        var case1 = ["<", ["get", type], 2];
        var case2 = ["all", [">=", ["get", type], 2], ["<", ["get", type], 3]];
        var case3 = ["all", [">=", ["get", type], 3], ["<", ["get", type], 4]];
        var case4 = ["all", [">=", ["get", type], 4], ["<", ["get", type], 5]];
        var case5 = [">=", ["get", type], 5];
        // colors to use for the categories

        var colors = type === "status" ? ["#f79c4b", "#08aa4f", "#5240b9", "#b9bbc7", "#f85859"] : ["#babbc8", "#5cab51", "#f5ae38", "#e95456"];

        // add a clustered GeoJSON source for a sample set of assets
        console.log(this.$store.getters.tickets_clustering);
        if (!map.getSource("assets"))
          map.addSource("assets", {
            type: "geojson",
            data: featuresCollection,
            //  "https://docs.mapbox.com/mapbox-gl-js/assets/assets.geojson",
            cluster: this.$store.getters.tickets_clustering,
            clusterRadius: 80,
            clusterProperties: {
              // keep separate counts for each magnitude category in a cluster
              case1: ["+", ["case", case1, 1, 0]],
              case2: ["+", ["case", case2, 1, 0]],
              case3: ["+", ["case", case3, 1, 0]],
              case4: ["+", ["case", case4, 1, 0]],
              case5: ["+", ["case", case5, 1, 0]],
            },
          });
        else map.getSource("assets").setData(featuresCollection);
        // circle and symbol layers for rendering individual assets (unclustered points)
        if (map.getLayer("asset_circle")) {
          map.removeLayer("asset_circle");
        }
        if (map.getLayer("asset_label")) {
          map.removeLayer("asset_label");
        }
        console.log("Adding layers....");
        map.addLayer({
          id: "asset_circle",
          type: "circle",
          source: "assets",
          filter: ["!=", "cluster", true],
          paint: {
            "circle-color": ["case", case1, colors[0], case2, colors[1], case3, colors[2], case4, colors[3], colors[4]],
            "circle-opacity": 0,
            "circle-radius": 12,
          },
        });
        map.addLayer({
          id: "asset_label",
          type: "symbol",
          source: "assets",
          filter: ["!=", "cluster", true],
          layout: {
            "icon-image": [
              "case",
              ["<=", ["get", type], 1],
              type + "1",
              ["<=", ["get", type], 2],
              type + "2",
              ["<=", ["get", type], 3],
              type + "3",
              ["<=", ["get", type], 4],
              type + "4",
              ["<=", ["get", type], 5],
              type + "5",
              type + "5",
            ],
            "icon-size": 1,
            "icon-allow-overlap": true,
          },
        });

        map.on("click", "asset_label", (e) => {
          this.open_details_popup(e.features[0].properties.ticket);
        });
        // objects for caching and keeping track of HTML marker objects (for performance)
        var markers = {};
        var markersOnScreen = {};

        function updateMarkers() {
          var newMarkers = {};
          var features = map.querySourceFeatures("assets");

          // for every cluster on the screen, create an HTML marker for it (if we didn't yet),
          // and add it to the map if it's not there already
          for (var i = 0; i < features.length; i++) {
            var coords = features[i].geometry.coordinates;
            var props = features[i].properties;
            if (!props.cluster) continue;
            var id = props.cluster_id;

            var marker = markers[id];
            if (!marker) {
              var el = createDonutChart(props);
              marker = markers[id] = new mapboxgl.Marker({
                element: el,
              }).setLngLat(coords);
              // new mapboxgl.Popup()
              //   .setLngLat(coords)
              //   .setHTML(props.ticket.name)
              //   .addTo(map);
            }
            newMarkers[id] = marker;
            if (!markersOnScreen[id]) marker.addTo(map);
          }
          // for every marker we've added previously, remove those that are no longer visible
          for (id in markersOnScreen) {
            if (!newMarkers[id]) markersOnScreen[id].remove();
          }
          markersOnScreen = newMarkers;
        }
        // after the GeoJSON data is loaded, update markers on the screen and do so on every map move/moveend
        map.on("data", function(e) {
          if (e.sourceId !== "assets" || !e.isSourceLoaded) return;

          map.on("move", updateMarkers);
          map.on("moveend", updateMarkers);
          updateMarkers();
        });

        // code for creating an SVG donut chart from feature properties
        function createDonutChart(props) {
          var offsets = [];
          var counts = [props.case1, props.case2, props.case3, props.case4, props.case5];
          var total = 0;
          for (var i = 0; i < counts.length; i++) {
            offsets.push(total);
            total += counts[i];
          }
          var fontSize = total >= 1000 ? 22 : total >= 100 ? 20 : total >= 10 ? 18 : 16;
          var r = total >= 1000 ? 50 : total >= 100 ? 32 : total >= 10 ? 24 : 18;
          var r0 = Math.round(r * 0.6);
          var w = r * 2;

          var html =
            '<div><svg width="' +
            w +
            '" height="' +
            w +
            '" viewbox="0 0 ' +
            w +
            " " +
            w +
            '" text-anchor="middle" style="font: ' +
            fontSize +
            'px sans-serif">';

          for (i = 0; i < counts.length; i++) {
            html += donutSegment(offsets[i] / total, (offsets[i] + counts[i]) / total, r, r0, colors[i]);
          }
          html +=
            '<circle cx="' +
            r +
            '" cy="' +
            r +
            '" r="' +
            r0 +
            '" fill="white" /><text dominant-baseline="central" transform="translate(' +
            r +
            ", " +
            r +
            ')">' +
            total.toLocaleString() +
            "</text></svg></div>";
          var el = document.createElement("div");
          el.innerHTML = html;

          return el.firstChild;
        }

        function donutSegment(start, end, r, r0, color) {
          // var el = document.createElement("div");
          // el.className = "marker";
          // el.style.backgroundImage = "url(img/icons/icon1.png)";
          // el.style.width = "40px";
          // el.style.height = "40px";

          // el.addEventListener("click", function() {
          //   window.alert(marker.properties.status);
          // });
          // return el.html;

          if (end - start === 1) end -= 0.00001;
          var a0 = 2 * Math.PI * (start - 0.25);
          var a1 = 2 * Math.PI * (end - 0.25);
          var x0 = Math.cos(a0),
            y0 = Math.sin(a0);
          var x1 = Math.cos(a1),
            y1 = Math.sin(a1);
          var largeArc = end - start > 0.5 ? 1 : 0;

          return [
            '<path d="M',
            r + r0 * x0,
            r + r0 * y0,
            "L",
            r + r * x0,
            r + r * y0,
            "A",
            r,
            r,
            0,
            largeArc,
            1,
            r + r * x1,
            r + r * y1,
            "L",
            r + r0 * x1,
            r + r0 * y1,
            "A",
            r0,
            r0,
            0,
            largeArc,
            0,
            r + r0 * x0,
            r + r0 * y0,
            '" fill="' + color + '" />',
          ].join(" ");
        }
      },
    },
  };
</script>

<style lang="scss">
  .cluster-dd-trigger {
    padding: 0.48rem;
    // box-shadow: -0.2px 0px 2px 0 rgba(0, 0, 0, 0.15);
  }
  .ticket-cluster-popup {
    padding: 10px;
    &.mapboxgl-popup {
      min-width: 330px !important;
    }
    .top {
      margin-left: -7px;
      display: flex;
      &-status,
      &-priority {
        display: flex;
        justify-content: center;
        font-family: Barlow-SemiBold;
        font-size: 14px;
        color: #171e48;
        font-weight: 600;
        text-transform: capitalize;
      }
      &-status {
        img {
          height: 35px;
        }
        p {
          margin-top: 4px;
        }
      }
      &-priority {
        margin-left: 10px;
        margin-top: -2px;
        img {
          height: 43px;
        }
        p {
          margin-top: 8px;
          margin-left: -3px;
        }
      }
    }
    .middle {
      margin-top: 4px;
      margin-bottom: 15px;
      font-size: 16px;
      font-family: Barlow-SemiBold;
      color: #171e48;
      font-weight: 600;
    }
    .bottom {
      font-size: 14px;
      font-weight: 500;
      display: flex;
      justify-content: space-between;
      &-due-date {
        display: flex;
        color: #fc5a5a;
        img {
          height: 19px;

          margin-right: 7px;
        }
      }
      &-see-more {
        color: #5c7ef7;
        img {
          height: 12px;
          margin-left: 7px;
        }
      }
    }
  }
  .ebs-count {
    position: fixed;
    right: 5.8rem;
    top: 0.9rem;
    z-index: 38;
    .dropdown-menu {
      border-radius: 8px;
      width: 277.7px;
      padding: 0 25px 31px 20px;
      box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.16);
      background-color: #fafcff;
      .cluster-heading {
        display: flex;
        justify-content: space-between;
        font-family: Barlow;
        font-size: 16px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 75px;
        letter-spacing: normal;
        text-align: left;
        color: #132068;
      }
      .middle {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5px;
        border-radius: 4px;
        border: solid 1px #d0d2da;
        background-color: #ffffff;
        .middle-button {
          text-transform: capitalize;
          font-family: Barlow;
          font-size: 16px;
          font-weight: 600;
          padding: 10px 20px;
          border-radius: 4px;
          img {
            margin-right: 5px;
          }
          &-active {
            color: white;
            border: solid 1px #d0d2da;
            background-color: #5c7ef7;
          }
        }
      }
      .clear-all {
        height: 40px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 10px;
        height: 40px;
        border-radius: 4px;
        border: solid 1px #d0d2da;
        background-color: #ffffff;
        -webkit-text-stroke: 1px rgba(0, 0, 0, 0);
        font-size: 16px;
        font-weight: 600;
        color: #171e48;
      }
    }
  }
</style>
